import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { FleetActions } from '../../../actions';
import SubnavBar from '../../../components/SubnavBar';
import TitleBar from '../../../components/TitleBar';
import Add from '../../../components/Fleet/Trailers/Add';

class Units extends Component {
  constructor(props) {
    super(props);

    this.saveTrailer = this.saveTrailer.bind(this);
  }
  goBack = () => {
    browserHistory.push('/fleet/trailers');
  }
  saveTrailer(values) {
    const { dispatch } = this.props;

    return dispatch(FleetActions.saveTrailer(values)).then((response) => {
      browserHistory.push('/fleet/trailers');
    });

  }
  render() {
    const subnavItems = []
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} back={this.goBack} />
          <TitleBar title="Add New Trailer" />
          <div className="row">
            <div className="col s12">
              <Add onSubmit={this.saveTrailer} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Units);



// WEBPACK FOOTER //
// ./src/containers/Fleet/Trailers/New.js